import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import {
  isFamilyResourcesPageInProgramFlex,
  isHighSchoolUrl,
  isMsSiteSelection,
  isK5SiteSelection,
} from 'utils/productHelpers'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-20164-k5-site-selection'],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => {
    const subscribedFlagsWithMsSiteSelectionTrue = {
      ...subscribedFlags,
      'feature_LEARN-20108-ms-site-selection': true,
    }

    return (
      isFamilyResourcesPageInProgramFlex() ||
      // allow for new HS Extension Activities
      isHighSchoolUrl() ||
      isMsSiteSelection(_, subscribedFlagsWithMsSiteSelectionTrue) ||
      isK5SiteSelection(_, subscribedFlags)
    )
  },
})

export default FlagToggler
